export default "<div class=\"bGPT\" ng-click=\"onClick()\">bGPT</div>";